import React, { useEffect, useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { useTranslation } from 'react-i18next'
import Card from '../../shared/card/Card'
import CardSeparator from '../../shared/card/CardSeparator'
import Select from '../../shared/form/Select'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectKey, mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import MaskInput, { Masks } from 'react-native-mask-input'
import moment from 'moment'
import { log } from 'console'

const IoInformatiomForm = ({ navigation, route }): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const intializeStore = useInitializeStore()
    const { loading, postiowaonline, getmodetails } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const [tax, selectedTax] = useState(null)
    const [filingstatus, setFilingStatus] = useState(null)

    const options3 = [
        { key: 1, value: 'Exempt' },
        { key: 2, value: 'Nonexempt' }
    ]

    const options2 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]
    const options1 = [
        { key: 1, value: 'Other(Including Single)' },
        { key: 2, value: 'Head of Household' },
        { key: 3, value: 'Married filing jointly' },
        { key: 4, value: 'Qualifying Surviving Spouse' }
    ]

    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
    }, [])

    const handlesubmit = async (values) => {
        const total =
            Number(values?.Personalallowances) +
            Number(values?.adjustmentsAllowances) +
            Number(values?.childAllowances) +
            Number(values?.dependentsAllowances) +
            Number(values?.itemizeddeductions) +
            Number(values?.personalExemption)
        const data = {
            essUserKey: intializeStore.initializeData?.userkey,
            entityId: personalstore.personalData?.entityId,
            exemptTax:
                values?.exempttax?.trim()?.toLowerCase() === 'exempt' ? true : false,
            filingStatus: values?.Filingstatus,
            spouseEarning: values?.isspouseEarning == 0 ? false : true,
            year: values.year ? values.year : null,
            exemptAsMiltary: values?.exemptasmiltary == 0 ? false : true,
            state: values.state ? values.state : '',
            personalAllowances: values.Personalallowances
                ? values.Personalallowances
                : null,
            dependentAllowances: values.dependentsAllowances
                ? values.dependentsAllowances
                : null,
            itemizedDeductions: values.itemizeddeductions
                ? values.itemizeddeductions
                : null,
            adjustmentAllowances: values?.adjustmentsAllowances
                ? values?.adjustmentsAllowances
                : null,
            childAllowances: values.childAllowances ? values.childAllowances : null,
            personalExemption: values?.personalExemption
                ? values?.personalExemption
                : null,
            additionalAmount: values.Additionalamount
                ? values.Additionalamount
                : null,
            totalAmount: total,
            formKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: mode === 'upload' ? false : true
        }

        const response: any = await postiowaonline(data)
        if (response?.success === true) {

            if (mode === 'online') {
                navigation.navigate('Ioonline', {
                    essUserOnBoardingKey,
                    essUserOnBoardingFormKey,
                    values,
                    completeOnline: mode === 'upload' ? false : true
                })
            } else {
                await Toast.show({
                    type: 'success',
                    position: 'bottom',
                    text1: response?.message,
                    visibilityTime: 3000,
                    autoHide: true,
                    topOffset: 60,
                    onHide: () => {
                        navigation.replace('OnboardingForms')
                    }
                })
            }
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    const intialValues = {
        Filingstatus: '',
        isspouseEarning: '',
        exempttax: '',
        year: '',
        exemptasmiltary: '',
        state: '',
        Personalallowances: '',
        dependentsAllowances: '',
        itemizeddeductions: '',
        adjustmentsAllowances: '',
        childAllowances: '',
        Additionalamount: '',
        personalExemption: ''
    }
    const w4schema = () => {
        const baseSchema = {
            Filingstatus: yup.string().required('Filing status is a required field'),
            isspouseEarning: yup
                .string()
                .when('Filingstatus', (Filingstatus: any, schema) => {
                    if (Filingstatus == '2' || Filingstatus == '3') {
                        return schema.required('Spouse Earning is a required field')
                    }
                    return schema.nullable()
                }),
            exempttax: yup
                .string()
                .nullable()
                .test(
                    'is-exempt-or-empty',
                    "Enter 'Exempt' or leave it empty",
                    (value) => !value || /^exempt$/i.test(value)
                ),
            year: yup
                .string()
                .nullable()
                .when('exempttax', {
                    is: (val: string) => typeof val === 'string' && /^exempt$/i.test(val),
                    then: (schema) => schema.required('Year is a required field'),
                    otherwise: (schema) => schema.nullable()
                }),
            exemptasmiltary: yup
                .string()
                .required('Exempt Tax  as a military spouse is a required field'),
            state: yup
                .string()
                .when('exemptasmiltary', (exemptasmiltary: any, schema) => {
                    if (exemptasmiltary == '1') {
                        return schema.required('State of Domicile is a required field')
                    }
                    return schema.nullable()
                }),
            Personalallowances: yup.string().nullable(),
            dependentsAllowances: yup.string().nullable(),
            itemizeddeductions: yup.string().nullable(),
            adjustmentsAllowances: yup.string().nullable(),
            childAllowances: yup.string().nullable(),
            Additionalamount: yup.string().nullable(),
            personalExemption: yup.string().nullable()
        }

        return yup.object(baseSchema)
    }
    const schema = w4schema()

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'IOWA Information'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        await handlesubmit(values)
                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Filing status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Filing status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.Filingstatus
                                            )}
                                            onSelect={(option: any) => {
                                                if (option == 1 || option == 2) {
                                                    props.setFieldValue('isspouseEarning', '')
                                                }
                                                props.setFieldValue('Filingstatus', option - 1)
                                                setFilingStatus(option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.Filingstatus &&
                                            props.errors.Filingstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.Filingstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {(filingstatus == 2 || filingstatus == 3) && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Does your spouse also have earned income *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Does your spouse also have earned income"
                                                options={options2}
                                                selectedOption={mapSelectValue(
                                                    options2,
                                                    props.values.isspouseEarning
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue('isspouseEarning', option - 1)
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.isspouseEarning &&
                                                props.errors.isspouseEarning && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.isspouseEarning}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'If you do not expect to owe any Iowa income tax and have a right to a full refund of ALL income tax withheld,Enter Exempt'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exempttax}
                                            onChangeText={(text) => {
                                                props.handleChange('exempttax')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('Additionalamount', '')
                                                }
                                            }}
                                        />
                                        {props.touched.exempttax && props.errors.exempttax && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.exempttax as string}
                                            </Text>
                                        )}
                                    </View>
                                </View>
                                {props.values.exempttax?.toLowerCase() == 'exempt' && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '48%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Enter the year effective here *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.year}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^[\d/-]+$/.test(text)) {
                                                        props.handleChange('year')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.year && props.errors.year && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.year}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                )}
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Check this box if you are claiming an exemption from lowa income tax as a military spouse based on the Military Spouses Residency Relief Act of 2009 or the Veterans Benefits and Transition Act of 2018 and the Veterans Auto and Education Improvement Act of 2022. *'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Check this box if you are claiming an exemption from lowa income tax as a military spouse based on the Military Spouses Residency Relief Act of 2009 or the Veterans Benefits and Transition Act of 2018 and the Veterans Auto and Education Improvement Act of 2022."
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options3,
                                                props.values.exemptasmiltary
                                            )}
                                            onSelect={(option: any) => {
                                                const val = option - 1
                                                props.setFieldValue('exemptasmiltary', val)
                                                if (val === 1) {
                                                    props.setFieldValue('Additionalamount', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.exemptasmiltary &&
                                            props.errors.exemptasmiltary && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.exemptasmiltary}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {Number(props.values.exemptasmiltary) == 1 && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Enter your state of domicile or residence here *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.state}
                                                onChangeText={(text) => {
                                                    props.handleChange('state')(text)
                                                }}
                                            />
                                            {props.touched.state && props.errors.state && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.state as string}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                )}

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Personal Allowances'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.Personalallowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('Personalallowances')(text)
                                                }
                                            }}
                                        />

                                        {props.touched.Personalallowances &&
                                            props.errors.Personalallowances && (
                                                <Text style={[globalStyles.dangerAlert]}>
                                                    {props.errors.Personalallowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Allowances for dependents. You may claim $40 for each dependent you claim on your Iowa income tax return'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.dependentsAllowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('dependentsAllowances')(text)
                                                }
                                            }}
                                        />

                                        {props.touched.dependentsAllowances &&
                                            props.errors.dependentsAllowances && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.dependentsAllowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Allowances for itemized deductions'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.itemizeddeductions}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('itemizeddeductions')(text)
                                                }
                                            }}
                                        />

                                        {props.touched.itemizeddeductions &&
                                            props.errors.itemizeddeductions && (
                                                <Text style={[globalStyles.dangerAlert]}>
                                                    {props.errors.itemizeddeductions}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {`Allowances for adjustments to income. Estimate allowable adjustments to income for
payments such as an IRA, Keogh, or SEP; penalty on early withdrawal of savings;
and student loan interest. Multiply this amount by 3.8% (.038), round to the nearest dollar `}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.adjustmentsAllowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('adjustmentsAllowances')(text)
                                                }
                                            }}
                                        />

                                        {props.touched.adjustmentsAllowances &&
                                            props.errors.adjustmentsAllowances && (
                                                <Text style={[globalStyles.dangerAlert]}>
                                                    {props.errors.adjustmentsAllowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {`Allowances for child and dependent care credit`}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.childAllowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('childAllowances')(text)
                                                }
                                            }}
                                        />

                                        {props.touched.childAllowances &&
                                            props.errors.childAllowances && (
                                                <Text style={[globalStyles.dangerAlert]}>
                                                    {props.errors.childAllowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {`Personal exemption credit allowed for federal purposes`}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.personalExemption}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('personalExemption')(text)
                                                }
                                            }}
                                        />

                                        {props.touched.personalExemption &&
                                            props.errors.personalExemption && (
                                                <Text style={[globalStyles.dangerAlert]}>
                                                    {props.errors.personalExemption}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {props.values.exempttax?.toLowerCase() !== 'exempt' && Number(props.values.exemptasmiltary) !== 1 && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {`Additional amount, if any, you want deducted each pay period`}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.Additionalamount}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('Additionalamount')(text)
                                                    }
                                                }}
                                            />

                                            {props.touched.Additionalamount &&
                                                props.errors.Additionalamount && (
                                                    <Text style={[globalStyles.dangerAlert]}>
                                                        {props.errors.Additionalamount}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}
                </Formik>
            </View>
        </KeyboardAwareScrollView>
    )
}
export default IoInformatiomForm